import Vue from 'vue'
import VuxToast from 'vux/src/components/toast'
import VuxButton from 'vux/src/components/x-button'

// components
Vue.component('VuxButton', VuxButton)
Vue.component('VNoSsr', {
  render (h) {
    return h()
  }
})

// class PluggableComponent {
//   static install (Vue) {
//     Vue.component(this.name, new this())
//   }
// }

class OneButton {
  static install (Vue) {
    Vue.component('OneButton', new this())
  }

  constructor () {
    return {
      props: {
        type: {
          default: 'default'
        },
        disabled: Boolean,
        mini: Boolean,
        plain: Boolean,
        text: String,
        actionType: String,
        showLoading: Boolean,
        link: [String, Object],
        gradients: {
          type: Array,
          validator: function (val) {
            return val.length === 2
          }
        }
      },

      render (h) {
        // const isLink = ('isLink' in this.$attrs)

        return h('VuxButton', {
          props: this.$props
        }, [
          this.$slots.default
        ])
      }
    }
  }
}

class OneIcon {
  static install (Vue) {
    Vue.component('OneIcon', new this())
  }

  constructor () {
    return {
      render (h) {
        return h('h1', 'this-is-h1-icon')
      }
    }
  }
}

class OneToast {
  static install (Vue) {
    Vue.component('OneToast', new this())
  }

  constructor () {
    if (!OneToast.$inst) {
      const ConstructOptions = Vue.extend(VuxToast)
      const inst = OneToast.$inst = new ConstructOptions({
        el: document.createElement('span')
      })
      document.body.appendChild(inst.$el)

      // hook global
      Vue.prototype.$toast = {
        show (options = {}) {
          if (typeof options === 'string') {
            options = {
              text: options
            }
          }

          Object.assign(inst, options)

          // inst.text = options.text
          inst.show = true
        },

        text (text, position = 'default', options = {}) {
          this.show({
            type: 'text',
            position,
            text,
            time: 3000,
            ...options
          })
        },

        success (text, position = 'default', options = {}) {
          this.show({
            type: 'success',
            position,
            text,
            ...options
          })
        },

        loading (text, position = 'default', options = {}) {
          this.show({
            type: 'loading',
            position,
            text,
            ...options
          })
        },

        error (text, position = 'default', options = {}) {
          this.show({
            type: 'warn',
            position,
            text,
            ...options
          })
        },

        hide () {
          inst.show = false
        },

        isVisible () {
          return inst.show
        }
      }
    }

    return VuxToast
  }
}

export {
  OneToast,
  OneButton,
  OneIcon
}
